import React from 'react';
import Helmet from 'react-helmet';

const UserNotActive = () => (
    <div className="container" style={{ padding: '80px 0' }}>
        <Helmet title="Pending approval" />
        <div className="ui message">
            <div className="content">
                <div className="header">
                    Pending approval
                </div>
                <p>Thanks for registering on the Clever Tykes portal. Your email address is pending verification. Feel free to navigate around the portal and view the free resources in the mean time.</p>
            </div>
        </div>
    </div>
);

export default UserNotActive;



/** WEBPACK FOOTER **
 ** ./src/pages/UserNotActive.js
 **/